import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UPDATE_STATUSES } from '../constants/content';
import {
  SITE_NAME,
  UPDATE_DURATION_MS,
  UPDATE_TICK_MS,
} from '../constants/site';
import TopBar from '../components/TopBar';

function formatRemain(ms) {
  const total = Math.max(0, Math.ceil(ms / 1000));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}

export default function UpdatingPage() {
  const navigate = useNavigate();
  const [elapsed, setElapsed] = useState(0);
  const [statusIndex, setStatusIndex] = useState(0);

  useEffect(() => {
    const started = Date.now();
    const tick = setInterval(() => {
      const next = Date.now() - started;
      if (next >= UPDATE_DURATION_MS) {
        clearInterval(tick);
        setElapsed(UPDATE_DURATION_MS);
        navigate('/complete', { replace: true });
        return;
      }
      setElapsed(next);
    }, 250);

    return () => clearInterval(tick);
  }, [navigate]);

  useEffect(() => {
    const rotator = setInterval(() => {
      setStatusIndex((i) => (i + 1) % UPDATE_STATUSES.length);
    }, UPDATE_TICK_MS);
    return () => clearInterval(rotator);
  }, []);

  const progress = Math.min(100, (elapsed / UPDATE_DURATION_MS) * 100);
  const remain = UPDATE_DURATION_MS - elapsed;

  return (
    <div className="page page--panel">
      <TopBar />
      <main className="panel">
        <div className="panel__card update-card">
          <div className="spinner" aria-hidden="true" />
          <p className="panel__eyebrow">Please wait</p>
          <h1>Updating {SITE_NAME}</h1>
          <p className="update-card__status" key={statusIndex}>
            {UPDATE_STATUSES[statusIndex]}
          </p>

          <div
            className="progress"
            role="progressbar"
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={Math.round(progress)}
            aria-label="Update progress"
          >
            <div className="progress__bar" style={{ width: `${progress}%` }} />
          </div>

          <div className="update-card__meta">
            <span>{Math.round(progress)}% complete</span>
            <span>{formatRemain(remain)} left</span>
          </div>

          <p className="update-card__note">
            Keep this page open until the update finishes. Do not close your
            browser or restart your computer.
          </p>
        </div>
      </main>
    </div>
  );
}
